import {
    CONFIRMED_CREATE_USER_FEV_ACTION,
    CONFIRMED_DELETE_USER_FEV_ACTION,
    CONFIRMED_EDIT_USER_FEV_ACTION,
    CONFIRMED_GET_USER_FEVS,
    CREATE_USER_FEV_ACTION,    
    CREATE_USER_FEV_ERROR_ACTION,
    CLEAR_USER_FEV_ERROR,
    LOADING_USER_FEVS    
} from '../actions/UserFevTypes';

const initialState = {
    user_FEVs: [],
    loading: false,
    createUser_FEVError: {}
};

export default function User_FEVReducer(state = initialState, actions) {
    if (actions.type === CREATE_USER_FEV_ACTION) { 
        return {
            ...state,
            user_FEVs: [...state.user_FEVs],
        };
    }

    if (actions.type === CONFIRMED_DELETE_USER_FEV_ACTION) {
        const user_FEVs = state.user_FEVs.filter(user_FEV => user_FEV.id !== actions.payload);
        return {
            ...state,
            user_FEVs,
        };
    }

    if (actions.type === CONFIRMED_EDIT_USER_FEV_ACTION) {
        const user_FEVs = state.user_FEVs.map(user_FEV => 
            user_FEV.id === actions.payload.id ? actions.payload : user_FEV
        );
        return {
            ...state,
            user_FEVs,
        };
    }

    if (actions.type === CONFIRMED_CREATE_USER_FEV_ACTION) {
        return {
            ...state,
            user_FEVs: [...state.user_FEVs, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_USER_FEVS) {
        return {
            ...state,
            user_FEVs: actions.payload,
        };
    }

    if (actions.type === LOADING_USER_FEVS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_USER_FEV_ERROR_ACTION) {
        return {
            ...state,
            createUser_FEVError: actions.payload,
        };
    }

    if (actions.type === CLEAR_USER_FEV_ERROR) {
        return {
            ...state,
            createUser_FEVError: {},
        };
    }
  
    return state;
}
